module.exports = "<div data-dojo-attach-point=\"focusNode\" tabindex=\"0\" role=\"menu\" data-focus=\"temporary\"></div>\n"